/* eslint-disable */
import Vue from 'vue'
import MainService from '@/services/MainService'

class ReportError {
  report = async (error:any) => {
    const data = {
      route: 'errors/report',
      params: {
        origin: 'ocular-widget-app',
        sessionId: error.sessionId,
        organizationId: error.organizationId,
        organizationName: error.organizationName,
        code: error.code,
        message: error.message,
        name: error.name,
        stack: error.stack
      }
    }

    // set analitic error
    Vue.prototype.$ocularAnalitycs.widgetAnalitycsEvent({
      action: error.name,
      detail: `CODE: ${error.code} - ${error.message}`,
      actionType: 'STAH',
      functionality: 7,
      historyInteractionType: 'CAMMER-SESSION-INFO'
    })

    return MainService.post(data)
      .then((response) => {
        const res = response.data
        if (res.statusCode === 0) {
          console.log('Error reported')
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {})
  }
}

Vue.prototype.$reportError = new ReportError()
